export const serviceTranslation = {
  en: {
    Services: "Services",
    "Add Service": "Add Service",
    "Edit Service": "Edit Service",
    Delete: "Delete",
    "Search by title": "Search by title...",
    "Title (EN)": "Title (EN)",
    "Description (EN)": "Description (EN)",
    "Title (AR)": "Title (AR)",
    "Description (AR)": "Description (AR)",
    Title: "Title",
    Icons: "Icons",
    URL: "URL",
    Status: "Status",
    Active: "Active",
    Inactive: "Inactive",
    "Are you sure you want to delete service '{{name}}'?":
      "Are you sure you want to delete service '{{name}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Created At": "Created At",
    Actions: "Actions",
    "Update Service": "Update Service",
    "Add New Service": "Add New Service",
    Cancel: "Cancel",
  },
  ar: {
    Services: "الخدمات",
    "Add Service": "إضافة خدمة",
    "Edit Service": "تعديل الخدمة",
    Delete: "حذف",
    "Search by title": "البحث حسب العنوان...",
    "Title (EN)": "العنوان (EN)",
    "Description (EN)": "الوصف (EN)",
    "Title (AR)": "العنوان (AR)",
    "Description (AR)": "الوصف (AR)",
    Title: "العنوان",
    Icons: "الأيقونات",
    URL: "الرابط",
    Status: "الحالة",
    Active: "نشط",
    Inactive: "غير نشط",
    "Are you sure you want to delete service '{{name}}'?":
      "هل أنت متأكد أنك تريد حذف الخدمة '{{name}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    "Update Service": "تحديث الخدمة",
    "Add New Service": "إضافة خدمة جديدة",
    Cancel: "إلغاء",
  },
};
